import { render } from "./selectAddress.vue?vue&type=template&id=c02af47a"
import script from "./selectAddress.vue?vue&type=script&lang=js"
export * from "./selectAddress.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__